/* GrowJoy Kids — Compost Chef (game, ages 6–12, guide: Wormy)
   Mounts into: <div data-kids-app="compost-chef" data-mascot="…wormy.jpg" data-badges='{"eco-friend":"…png",…}'></div>
   Needs: kids-shared.css, kids-badges.js. No other dependencies, no network calls.
   Learning: what can go in a home compost (greens + browns), what is recycled, what is rubbish,
   and that compost turns kitchen and garden scraps into rich soil. */
(function () {
  "use strict";

  /* ---------- content (horticultural review pending — see CONTENT-REVIEW.md) ----------
     bin: compost | recycle | rubbish     kind (compost only): green | brown | extra */
  var ITEMS = [
    { id: "banana",  name: "Banana peel",     bin: "compost", kind: "green", fact: "Fruit peels rot quickly and feed the soil. They are 'greens': wet and fresh." },
    { id: "apple",   name: "Apple core",      bin: "compost", kind: "green", fact: "Fruit scraps are greens. Worms and tiny microbes love them." },
    { id: "veg",     name: "Vegetable scraps", bin: "compost", kind: "green", fact: "Peels, stalks and tops from vegetables are perfect greens." },
    { id: "grass",   name: "Grass clippings", bin: "compost", kind: "green", fact: "Fresh grass is a green. Mix it with dry browns so it doesn't get slimy." },
    { id: "leaves",  name: "Dry leaves",      bin: "compost", kind: "brown", fact: "Dry leaves are 'browns'. Browns keep compost light, airy and not smelly." },
    { id: "twigs",   name: "Small twigs",     bin: "compost", kind: "brown", fact: "Small dry twigs are browns. Break them up so they rot faster." },
    { id: "eggshell",name: "Eggshells",       bin: "compost", kind: "extra", fact: "Crushed eggshells add calcium. Crush them small first." },
    { id: "bottle",  name: "Plastic bottle",  bin: "recycle", fact: "Rinse it, then recycle it so it can become something new." },
    { id: "can",     name: "Drink can",       bin: "recycle", fact: "Cans can be recycled again and again." },
    { id: "jar",     name: "Glass jar",       bin: "recycle", fact: "Clean glass jars can be recycled into new glass." },
    { id: "chips",   name: "Chip packet",     bin: "rubbish", fact: "Shiny snack packets are made of mixed layers, so most can't be recycled or composted." },
    { id: "bone",    name: "Chicken bone",    bin: "rubbish", fact: "Meat and bones don't go in a home compost. They smell and attract rats." },
    { id: "foam",    name: "Foam food box",   bin: "rubbish", fact: "Foam boxes don't rot and are hard to recycle. Bring your own container next time!" },
    { id: "wrapper", name: "Sweet wrapper",   bin: "rubbish", fact: "Sweet wrappers can't be composted or easily recycled." }
  ];
  var BINS = {
    compost: { name: "Compost", hint: "Food & garden scraps", key: "1" },
    recycle: { name: "Recycle", hint: "Bottles, cans, jars", key: "2" },
    rubbish: { name: "Rubbish", hint: "Everything else", key: "3" }
  };
  var ROUND = 14;          // items per game
  var COMPOST_GOAL = 7;    // compost items needed to fill the bin

  function mount(root) {
    var mascot = root.getAttribute("data-mascot") || "";
    var mascotReaction = root.getAttribute("data-mascot-reaction") || mascot;
    var badges = {}; try { badges = JSON.parse(root.getAttribute("data-badges") || "{}"); } catch (e) {}
    var reduced = window.GrowJoyUI.reduced();
    var g = null, raf = 0, last = 0, drag = null;

    root.classList.add("gj");
    root.innerHTML =
      '<div class="gj-game">' +
        '<div class="gj-main">' +
          '<div class="gj-titlebar"><div><h1>Compost Chef</h1><p class="gj-sub">Sort the scraps and cook up rich soil.</p></div><span class="gj-chip">Ages 6–12</span></div>' +
          '<div class="gj-hud">' +
            '<div class="gj-meter" style="grid-column:span 2"><span>Compost bin <em data-r="cnum">0 of ' + COMPOST_GOAL + '</em></span>' +
              '<div class="cc-mix" data-r="mix"><i data-r="mg" style="background:#57b84a;width:0"></i><i data-r="mb" style="background:#9a6a3c;width:0"></i><i data-r="me" style="background:#e9dcc0;width:0"></i></div>' +
              '<div class="cc-legend"><span style="--c:#57b84a">Greens</span><span style="--c:#9a6a3c">Browns</span><span style="--c:#e9dcc0">Extras</span></div></div>' +
            '<div class="gj-meter" style="align-items:flex-end"><span class="gj-num" data-r="score">0</span><span data-r="left" style="color:var(--gj-muted)">Item 1 of ' + ROUND + "</span></div>" +
          "</div>" +
          '<div class="gj-stage cc-stage" data-r="stage" tabindex="0" aria-label="Compost Chef game area. Press 1 for compost, 2 for recycle, 3 for rubbish.">' +
            '<div class="cc-sun" aria-hidden="true"></div>' + ground() +
            '<div class="cc-item" data-r="item" role="img" hidden></div>' +
            '<div class="cc-bins" data-r="bins">' + Object.keys(BINS).map(function (k) {
              return '<button type="button" class="cc-bin ' + k + '" data-bin="' + k + '">' + binIcon(k) + "<b>" + BINS[k].name + "</b><small>" + BINS[k].hint + "</small><kbd>" + BINS[k].key + "</kbd></button>";
            }).join("") + "</div>" +
            '<div class="gj-overlay" data-r="ov"></div></div>' +
          '<div class="gj-guide" data-r="guide" aria-live="polite"><img src="' + mascot + '" alt="Wormy the earthworm"><p data-r="tip"></p></div>' +
        "</div>" +
        '<aside class="gj-side">' +
          '<div class="gj-card"><h3>How to play</h3><ul class="gj-howto">' +
            '<li><b class="k">Look</b>Something falls from the sky. What is it?</li>' +
            '<li><b class="k">Tap</b>Tap the right bin, or drag it into the bin.</li>' +
            '<li><b class="k">Fill</b>Fill the compost bin with greens and browns.</li>' +
            '<li><b class="k">Win</b>Turn your compost into rich soil!</li></ul>' +
            '<p class="gj-keys">Keyboard: press 1 Compost, 2 Recycle, 3 Rubbish · P pauses</p></div>' +
          '<div class="gj-card"><h3>What goes where</h3><div class="cc-where" data-r="where"></div></div>' +
          '<div class="gj-card"><h3>Your badges</h3><div class="gj-shelf" data-r="shelf" style="margin-top:8px"></div></div>' +
        "</aside>" +
      "</div>";

    var $ = function (k) { return root.querySelector('[data-r="' + k + '"]'); };
    var stage = $("stage"), itemEl = $("item"), binsEl = $("bins");

    function shelf() { window.GrowJoyUI.shelf($("shelf"), function (id) { return badges[id] || ""; }); }
    function tip(html, mood) { $("tip").innerHTML = html; $("guide").className = "gj-guide" + (mood ? " " + mood : ""); $("guide").querySelector("img").src = mood === "good" ? mascotReaction : mascot; }
    function where() {
      var seen = g ? g.seen : {};
      $("where").innerHTML = Object.keys(BINS).map(function (k) {
        var names = ITEMS.filter(function (it) { return it.bin === k && seen[it.id]; }).map(function (it) { return it.name; });
        return "<div><b>" + BINS[k].name + "</b>" + (names.length ? names.join(", ") : "<span style='color:var(--gj-muted)'>Nothing yet</span>") + "</div>";
      }).join("");
    }

    /* Pick 14 items: all 7 compost items plus 7 of the others, shuffled, so the bin can always be filled. */
    function deck() {
      var compost = ITEMS.filter(function (i) { return i.bin === "compost"; });
      var other = shuffle(ITEMS.filter(function (i) { return i.bin !== "compost"; })).slice(0, ROUND - compost.length);
      return shuffle(compost.concat(other));
    }
    function shuffle(a) { a = a.slice(); for (var i = a.length - 1; i > 0; i--) { var j = Math.floor(Math.random() * (i + 1)); var t = a[i]; a[i] = a[j]; a[j] = t; } return a; }

    function fresh() { return { deck: deck(), i: 0, score: 0, right: 0, wrong: 0, fill: { green: 0, brown: 0, extra: 0 }, seen: {}, mode: "intro", y: 0, cur: null }; }

    /* ---------- flow ---------- */
    function begin() {
      g = fresh(); g.mode = "play"; $("ov").hidden = true; where(); hud();
      tip("<b>Here comes the first one!</b> Where should it go?", null);
      next();
      stage.focus({ preventScroll: true });
    }
    function fallTime() { return Math.max(4.2, 7.5 - g.i * 0.25) * (reduced ? 1.4 : 1); }
    function next() {
      if (g.i >= ROUND) return finish();
      g.cur = g.deck[g.i]; g.y = 0; g.landing = false;
      itemEl.className = "cc-item"; itemEl.style.transform = ""; itemEl.style.left = ""; itemEl.style.top = "0px";
      itemEl.innerHTML = itemIcon(g.cur.id) + "<span>" + g.cur.name + "</span>";
      itemEl.setAttribute("aria-label", "Falling: " + g.cur.name + ". Press 1 for compost, 2 for recycle, 3 for rubbish.");
      itemEl.hidden = false;
      hud();
      last = performance.now(); cancelAnimationFrame(raf); raf = requestAnimationFrame(loop);
    }
    function landY() { return stage.clientHeight - binsEl.offsetHeight - 118; }
    function loop(now) {
      if (g.mode !== "play") return;
      var dt = Math.min(0.05, (now - last) / 1000); last = now;
      if (!drag) {
        g.y += landY() / fallTime() * dt;
        itemEl.style.top = g.y + "px";
        if (!reduced) itemEl.style.transform = "rotate(" + Math.sin(now / 400) * 6 + "deg)";
        if (g.y >= landY()) return missed();
      }
      raf = requestAnimationFrame(loop);
    }
    function missed() {
      g.wrong++; g.seen[g.cur.id] = true;
      tip("<b>Oops, it fell on the ground!</b> Litter makes the garden sad. The " + g.cur.name.toLowerCase() + " goes in <b>" + BINS[g.cur.bin].name + "</b>. " + g.cur.fact, "oops");
      flash(g.cur.bin, "right");
      g.cur = null; g.i++; where(); setTimeout(function () { if (g.mode === "play") next(); }, 1500);
      itemEl.hidden = true;
    }
    function sort(bin) {
      if (!g || g.mode !== "play" || !g.cur || itemEl.hidden) return;
      cancelAnimationFrame(raf);
      var it = g.cur, ok = it.bin === bin; g.seen[it.id] = true;
      var b = binsEl.querySelector('[data-bin="' + bin + '"]');
      if (ok) {
        g.right++; g.score += 10;
        if (it.bin === "compost") { g.fill[it.kind]++; g.score += 5; }
        var label = it.kind === "green" ? '<span class="gj-tag good">Green</span>' : it.kind === "brown" ? '<span class="gj-tag" style="background:#9a6a3c">Brown</span>' : "";
        tip(label + "<b>Yes! " + BINS[bin].name + ".</b> " + it.fact, "good");
        flash(bin, "right");
      } else {
        g.wrong++;
        tip("<b>Not quite!</b> The " + it.name.toLowerCase() + " goes in <b>" + BINS[it.bin].name + "</b>. " + it.fact, "oops");
        flash(bin, "wrong"); flash(it.bin, "right");
      }
      /* fly the item into the bin it was sent to */
      var br = b.getBoundingClientRect(), ir = itemEl.getBoundingClientRect();
      itemEl.style.transform = "translate(" + (br.left + br.width / 2 - (ir.left + ir.width / 2)) + "px," + (br.top - ir.top) + "px) scale(.4)";
      itemEl.classList.add("fly");
      g.cur = null; g.i++; hud(); where();
      setTimeout(function () { if (g.mode === "play") next(); }, ok ? 900 : 1700);
    }
    function flash(bin, cls) {
      var b = binsEl.querySelector('[data-bin="' + bin + '"]'); if (!b) return;
      b.classList.remove("right", "wrong"); void b.offsetWidth; b.classList.add(cls);
    }
    function finish() {
      g.mode = "soil"; itemEl.hidden = true; cancelAnimationFrame(raf);
      var o = $("ov");
      o.innerHTML = soilSvg() + "<h2>Now the compost cooks…</h2><p>Wormy, tiny bugs and microbes munch the scraps. After a few weeks, the greens and browns turn into dark, crumbly soil.</p>" +
        '<div class="gj-actions"><button type="button" class="gj-btn">See what happened</button></div>';
      o.hidden = false;
      var b = o.querySelector("button"); b.focus({ preventScroll: true });
      b.addEventListener("click", function () {
        g.mode = "done";
        var acc = g.right / ROUND, stars = acc >= 0.9 ? 3 : acc >= 0.7 ? 2 : 1;
        window.GrowJoyUI.celebrate({
          stage: stage, overlay: o, badgeId: "eco-friend", badgeSrc: badges["eco-friend"] || "", stars: stars,
          title: "You made rich soil!",
          text: "You sorted " + g.right + " of " + ROUND + " correctly. Plants grow strong in compost soil. Ask a grown-up about starting a compost bin at home or school!",
          again: begin
        });
        tip("<b>Wiggle wiggle, hooray!</b> Greens + browns + time = rich soil for your plants.", "good");
        shelf();
      });
    }
    function pause() {
      if (!g || g.mode !== "play") return;
      g.mode = "paused"; cancelAnimationFrame(raf);
      var o = $("ov"); o.innerHTML = "<h2>Paused</h2><p>The scraps will wait for you.</p>" + '<div class="gj-actions"><button type="button" class="gj-btn">Keep playing</button></div>'; o.hidden = false;
      var b = o.querySelector("button"); b.focus({ preventScroll: true });
      b.addEventListener("click", function () { g.mode = "play"; o.hidden = true; stage.focus({ preventScroll: true }); if (!g.cur) { next(); return; } last = performance.now(); raf = requestAnimationFrame(loop); });
    }
    function hud() {
      var f = g ? g.fill : { green: 0, brown: 0, extra: 0 }, n = f.green + f.brown + f.extra;
      $("cnum").textContent = Math.min(n, COMPOST_GOAL) + " of " + COMPOST_GOAL;
      $("mg").style.width = (f.green / COMPOST_GOAL * 100) + "%";
      $("mb").style.width = (f.brown / COMPOST_GOAL * 100) + "%";
      $("me").style.width = (f.extra / COMPOST_GOAL * 100) + "%";
      $("score").textContent = g ? g.score : 0;
      $("left").textContent = "Item " + Math.min(ROUND, (g ? g.i : 0) + 1) + " of " + ROUND;
    }

    /* ---------- input ---------- */
    binsEl.addEventListener("click", function (ev) { var b = ev.target.closest(".cc-bin"); if (b) sort(b.getAttribute("data-bin")); });
    document.addEventListener("keydown", function (ev) {
      if (!g || root.offsetParent === null || !root.contains(document.activeElement)) return;
      if (document.activeElement.matches('input, textarea, select, [contenteditable]')) return;
      if (ev.key === "1") sort("compost");
      else if (ev.key === "2") sort("recycle");
      else if (ev.key === "3") sort("rubbish");
      else if (ev.key === "p" || ev.key === "P" || ev.key === "Escape") pause();
    });
    itemEl.addEventListener("pointerdown", function (ev) {
      if (!g || g.mode !== "play") return;
      var r = itemEl.getBoundingClientRect();
      drag = { dx: ev.clientX - (r.left + r.width / 2), dy: ev.clientY - r.top };
      itemEl.setPointerCapture(ev.pointerId); itemEl.classList.add("drag");
    });
    itemEl.addEventListener("pointermove", function (ev) {
      if (!drag) return;
      var s = stage.getBoundingClientRect();
      itemEl.style.left = (ev.clientX - s.left - drag.dx) + "px";
      itemEl.style.top = (ev.clientY - s.top - drag.dy) + "px";
      var over = binUnder(ev.clientX, ev.clientY);
      binsEl.querySelectorAll(".cc-bin").forEach(function (b) { b.classList.toggle("hot", b === over); });
    });
    function drop(ev) {
      if (!drag) return;
      drag = null; itemEl.classList.remove("drag");
      var over = binUnder(ev.clientX, ev.clientY);
      binsEl.querySelectorAll(".cc-bin").forEach(function (b) { b.classList.remove("hot"); });
      if (over) sort(over.getAttribute("data-bin"));
      else { itemEl.style.left = ""; g.y = Math.min(g.y, landY() - 10); }
    }
    itemEl.addEventListener("pointerup", drop);
    itemEl.addEventListener("pointercancel", drop);
    function binUnder(x, y) {
      var hit = null;
      binsEl.querySelectorAll(".cc-bin").forEach(function (b) { var r = b.getBoundingClientRect(); if (x >= r.left && x <= r.right && y >= r.top - 30 && y <= r.bottom) hit = b; });
      return hit;
    }
    document.addEventListener("visibilitychange", function () { if (document.hidden) pause(); });

    /* ---------- boot ---------- */
    shelf(); where(); hud();
    tip("<b>Hi, I'm Wormy!</b> I turn scraps into soil. Will you help me sort them?", null);
    var o = $("ov");
    o.innerHTML = '<img class="gj-mascot" src="' + mascot + '" alt=""><p>Help Wormy sort the scraps.</p>' +
      '<div class="gj-actions"><button type="button" class="gj-btn">Start</button></div>';
    o.querySelector("button").addEventListener("click", begin);
  }

  /* ---------- artwork (simple SVGs drawn in code; swap for illustrator art later) ---------- */
  function ground() {
    return '<svg class="cc-ground" viewBox="0 0 400 140" preserveAspectRatio="none" aria-hidden="true"><path d="M0 30 Q100 0 200 22 T400 18 V140 H0Z" fill="#8bc76f"/><path d="M0 60 Q120 36 220 56 T400 50 V140 H0Z" fill="#6aae55"/></svg>';
  }
  function binIcon(k) {
    if (k === "compost") return '<svg viewBox="0 0 54 54" aria-hidden="true"><rect x="9" y="16" width="36" height="32" rx="5" fill="#fff" opacity=".95"/><rect x="6" y="11" width="42" height="8" rx="4" fill="#fff"/><path d="M20 38c0-7 7-11 14-11-1 7-6 12-14 11zM20 38c-1-5 1-9 6-11" stroke="#2f8f3e" stroke-width="2.5" fill="#bfe6b0"/></svg>';
    if (k === "recycle") return '<svg viewBox="0 0 54 54" aria-hidden="true"><rect x="9" y="16" width="36" height="32" rx="5" fill="#fff" opacity=".95"/><rect x="6" y="11" width="42" height="8" rx="4" fill="#fff"/><path d="M27 24l5 8h-4l-1 8M20 40l-4-7 4-2M34 40h-9" stroke="#1e7fd0" stroke-width="3" fill="none" stroke-linecap="round" stroke-linejoin="round"/></svg>';
    return '<svg viewBox="0 0 54 54" aria-hidden="true"><rect x="9" y="16" width="36" height="32" rx="5" fill="#fff" opacity=".95"/><rect x="6" y="11" width="42" height="8" rx="4" fill="#fff"/><path d="M20 24v18M27 24v18M34 24v18" stroke="#5f6b66" stroke-width="3" stroke-linecap="round"/></svg>';
  }
  function itemIcon(id) {
    var s = {
      banana: '<path d="M8 36c10 16 38 14 46-14-3-3-6-2-7 0-6 16-22 20-35 12z" fill="#f6d23a" stroke="#b58a12" stroke-width="2"/><path d="M47 22l4-6" stroke="#6b4a1a" stroke-width="4" stroke-linecap="round"/><path d="M14 40c-4 4-6 8-4 12 4-2 7-6 8-9" fill="#f6d23a" stroke="#b58a12" stroke-width="2"/>',
      apple: '<path d="M18 12c4-6 20-6 24 0-2 4-22 4-24 0zM18 50c4 6 20 6 24 0-2-4-22-4-24 0z" fill="#e8463a"/><path d="M20 14c6 8 6 26 0 34h20c-6-8-6-26 0-34z" fill="#fbf1d6" stroke="#e7d7a8" stroke-width="2"/><path d="M30 10V2" stroke="#6b4a1a" stroke-width="3" stroke-linecap="round"/><ellipse cx="30" cy="28" rx="2" ry="3" fill="#6b4a1a"/><ellipse cx="30" cy="36" rx="2" ry="3" fill="#6b4a1a"/>',
      veg: '<path d="M30 30L18 56c6 2 10-2 12-6l8-18z" fill="#f08a24" stroke="#c96a12" stroke-width="2"/><path d="M32 30c-6-10-14-14-20-12 4 6 10 10 20 12zM34 28c0-10 4-18 10-20 0 8-4 16-10 20zM33 29c4-6 12-8 18-6-4 6-12 8-18 6z" fill="#3e9a49"/>',
      grass: '<path d="M10 54l6-30 4 30M20 54l8-40 4 40M32 54l6-34 4 34M42 54l8-28 2 28" fill="#57b84a" stroke="#2f8f3e" stroke-width="2" stroke-linejoin="round"/>',
      leaves: '<path d="M10 46C10 22 30 10 52 12c0 22-14 38-42 34z" fill="#b8742f" stroke="#7d4a18" stroke-width="2"/><path d="M12 46C24 34 34 24 48 15M24 36l-2-10M32 29l8 1" stroke="#7d4a18" stroke-width="2" fill="none" stroke-linecap="round"/>',
      twigs: '<path d="M8 44L52 18M20 37l-6-12M36 28l6 10M44 23l2-12" stroke="#8a5a2b" stroke-width="5" stroke-linecap="round"/>',
      eggshell: '<path d="M8 40c0-14 8-24 16-24s14 10 14 24l-5-5-4 6-5-6-5 6-4-6z" fill="#fbf3e2" stroke="#d8c7a2" stroke-width="2"/><path d="M30 46c0-10 6-18 12-18s12 8 12 18l-4-4-4 5-4-5-4 5-4-5z" fill="#f3e3c2" stroke="#d8c7a2" stroke-width="2"/>',
      bottle: '<rect x="24" y="4" width="12" height="7" rx="2" fill="#1e7fd0"/><path d="M24 11h12v6c6 3 8 7 8 12v24a4 4 0 0 1-4 4H20a4 4 0 0 1-4-4V29c0-5 2-9 8-12z" fill="#cfeaf8" stroke="#7fb8d6" stroke-width="2"/><rect x="16" y="32" width="28" height="10" fill="#1e8fe1" opacity=".8"/>',
      can: '<rect x="16" y="8" width="28" height="46" rx="5" fill="#d7dde0" stroke="#9aa5ab" stroke-width="2"/><rect x="16" y="22" width="28" height="18" fill="#e8463a"/><ellipse cx="30" cy="9" rx="13" ry="3" fill="#b9c2c6"/>',
      jar: '<rect x="18" y="6" width="24" height="9" rx="2" fill="#f6b81f"/><path d="M16 15h28v34a6 6 0 0 1-6 6H22a6 6 0 0 1-6-6z" fill="#dff3e6" stroke="#8cc7a1" stroke-width="2"/><path d="M22 22v24" stroke="#fff" stroke-width="3" stroke-linecap="round" opacity=".9"/>',
      chips: '<path d="M14 10l4 3 4-3 4 3 4-3 4 3 4-3 4 3 4-3v42l-4-3-4 3-4-3-4 3-4-3-4 3-4-3-4 3z" fill="#8b4fd0" stroke="#5e2f99" stroke-width="2" stroke-linejoin="round"/><ellipse cx="30" cy="31" rx="9" ry="6" fill="#f6c444"/>',
      bone: '<path d="M18 22a6 6 0 1 1 6-8l18 18a6 6 0 1 1 8 6 6 6 0 1 1-8 6L24 26a6 6 0 1 1-6-4z" fill="#f6efe1" stroke="#cdbf9f" stroke-width="2"/>',
      foam: '<path d="M8 30h44l-4 18H12z" fill="#fff" stroke="#c9d2d6" stroke-width="2"/><path d="M8 30l6-16h32l6 16z" fill="#f4f7f8" stroke="#c9d2d6" stroke-width="2"/>',
      wrapper: '<path d="M18 22l-12-8 2 32 10-8zM42 22l12-8-2 32-10-8z" fill="#ec4f86" stroke="#b83062" stroke-width="2" stroke-linejoin="round"/><rect x="16" y="20" width="28" height="20" rx="8" fill="#f78fb3" stroke="#b83062" stroke-width="2"/>'
    }[id] || "";
    return '<svg viewBox="0 0 60 60" aria-hidden="true">' + s + "</svg>";
  }
  function soilSvg() {
    return '<svg class="cc-soil" viewBox="0 0 220 150" aria-hidden="true"><ellipse cx="110" cy="132" rx="96" ry="14" fill="#5c3b22"/><path d="M20 130c8-34 40-52 90-52s82 18 90 52z" fill="#4a2e18"/>' +
      '<circle cx="70" cy="110" r="4" fill="#6b4626"/><circle cx="130" cy="100" r="3" fill="#6b4626"/><circle cx="160" cy="118" r="4" fill="#6b4626"/>' +
      '<path d="M110 80V40" stroke="#2a6f33" stroke-width="6" stroke-linecap="round"/><path d="M110 50c-10-14-26-12-28-2 10 6 20 6 28 2zM110 44c10-16 28-14 30-4-10 8-22 8-30 4z" fill="#3e9a49"/>' +
      '<path d="M54 120c6-10 14-10 18-2s12 8 16-2" stroke="#e38d8d" stroke-width="7" fill="none" stroke-linecap="round"/></svg>';
  }

  function init() { document.querySelectorAll('[data-kids-app="compost-chef"]').forEach(mount); }
  if (document.readyState === "loading") document.addEventListener("DOMContentLoaded", init); else init();
})();
